export class PlayerManager {
    constructor(desiredVideoQuality, logger) {
        this.desiredVideoQuality = desiredVideoQuality;
        this.logger = logger;
        this.players = new Map();
    }
    registerPlayer(type, player) {
        if (this.players.has(type)) {
            this.logger.error(`[PlayerManager] Player for type "${type}" is already registered.`);
            throw new Error(`Player for type "${type}" is already registered.`);
        }
        this.players.set(type, player);
    }
    getPlayer(type) {
        const player = this.players.get(type);
        if (!player) {
            this.logger.error(`[PlayerManager] Player for type "${type}" is already registered.`);
            throw new Error(`Player for type "${type}" is not registered.`);
        }
        return player;
    }
    initialize() {
        this.players.forEach(player => player.initialize());
    }
    play(item, when) {
        this.getPlayer(item.playable.type).play(item, when);
    }
    stop(item, when, force = false) {
        this.getPlayer(item.playable.type).stop(item, when, force);
    }
    queue(item, from, until) {
        const player = this.getPlayer(item.playable.type);
        player.queue(item, from, until);
    }
    preload(item) {
        this.getPlayer(item.playable.type).preload(item);
    }
    idle(isSomethingPlanned, nextItemAt, isExiting) {
        this.players.forEach(player => player.idle(isSomethingPlanned, nextItemAt, isExiting));
    }
    sync(item, seekTo, when) {
        this.getPlayer(item.playable.type).sync(item, seekTo, when);
    }
    async destroy() {
        this.logger.debug('[PlayerManager] Destroying all registered players...');
        for (const player of this.players.values()) {
            await player.destroy();
        }
    }
}
//# sourceMappingURL=PlayerManager.js.map